/**
 * Поля розділу «Процеси й регламенти» → поняття довідника (значок «?» біля підпису поля).
 * Ключ — `kb.<сутність>.<поле>`, значення — термін словника (усі чотири є в початковому словнику).
 */
export const REGISTRY_FIELD_TERMS: Readonly<Record<string, string>> = {
  'kb.process.valuableFinalProduct': 'ЦКП',
  'kb.process.level': 'L0–L5',
  'kb.position.valuableFinalProduct': 'ЦКП',
  'kb.position.folder': 'Посадова папка',
};
